/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  SubmitInformationRequestOnBehalfMutationResponse,
  SubmitInformationRequestOnBehalfPathParams,
} from "../types/SubmitInformationRequestOnBehalf.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const submitInformationRequestOnBehalfMutationKey = () =>
  [{ url: "/v1/information-request/:id/submit-on-behalf" }] as const

export type SubmitInformationRequestOnBehalfMutationKey = ReturnType<
  typeof submitInformationRequestOnBehalfMutationKey
>

/**
 * @summary Submit an information request on behalf of a supplier
 * {@link /v1/information-request/:id/submit-on-behalf}
 */
export async function submitInformationRequestOnBehalf(
  id: SubmitInformationRequestOnBehalfPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SubmitInformationRequestOnBehalfMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/information-request/${id}/submit-on-behalf`,
    ...requestConfig,
  })
  return res
}

export function submitInformationRequestOnBehalfMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = submitInformationRequestOnBehalfMutationKey()
  return mutationOptions<
    ResponseConfig<SubmitInformationRequestOnBehalfMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: SubmitInformationRequestOnBehalfPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return submitInformationRequestOnBehalf(id, config)
    },
  })
}

/**
 * @summary Submit an information request on behalf of a supplier
 * {@link /v1/information-request/:id/submit-on-behalf}
 */
export function useSubmitInformationRequestOnBehalf<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<SubmitInformationRequestOnBehalfMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: SubmitInformationRequestOnBehalfPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? submitInformationRequestOnBehalfMutationKey()

  const baseOptions = submitInformationRequestOnBehalfMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<SubmitInformationRequestOnBehalfMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: SubmitInformationRequestOnBehalfPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<SubmitInformationRequestOnBehalfMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: SubmitInformationRequestOnBehalfPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<SubmitInformationRequestOnBehalfMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: SubmitInformationRequestOnBehalfPathParams["id"] },
    TContext
  >
}
